import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const More: FunctionalComponent<IIconProps> = ({ width = '20', height = '20', fill = '#333' }) => {
  return (
    /*@ts-ignore*/
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
      <path
        d="M4.16667 8.3335C3.25 8.3335 2.5 9.0835 2.5 10.0002C2.5 10.9168 3.25 11.6668 4.16667 11.6668C5.08333 11.6668 5.83333 10.9168 5.83333 10.0002C5.83333 9.0835 5.08333 8.3335 4.16667 8.3335ZM15.8333 8.3335C14.9166 8.3335 14.1666 9.0835 14.1666 10.0002C14.1666 10.9168 14.9166 11.6668 15.8333 11.6668C16.75 11.6668 17.5 10.9168 17.5 10.0002C17.5 9.0835 16.75 8.3335 15.8333 8.3335ZM10 8.3335C9.08337 8.3335 8.33337 9.0835 8.33337 10.0002C8.33337 10.9168 9.08337 11.6668 10 11.6668C10.9167 11.6668 11.6667 10.9168 11.6667 10.0002C11.6667 9.0835 10.9167 8.3335 10 8.3335Z"
        fill={fill}
      />
    </svg>
  );
};

export default More;
